import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eye",
  "use": "eye-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"eye\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#CFCFCF\" stroke-width=\"2\">\n        <path stroke-linecap=\"round\" d=\"M18.51 15a4 4 0 1 0 4 4\" />\n        <path stroke-linejoin=\"round\" d=\"M18 12c5.156 0 9.704 2.774 12.404 7-2.701 4.226-7.249 7-12.404 7s-9.703-2.774-12.403-6.999C8.297 14.774 12.844 12 18 12z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol